var _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJoobler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#EAF3FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_668_1418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#EAF3FE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_668_1418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7502 51.6575C42.3553 53.7924 32.6711 52.1079 27.5066 51.449L22.1289 53.0413V64.3587C39.6252 72.3451 47.1877 60.3061 48.7819 53.2884C47.8652 53.2884 45.0455 52.2011 43.7502 51.6575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6657 106.047C31.8683 105.931 32.774 103.848 32.8754 102.703C35.7845 100.797 35.7808 99.2102 35.5453 98.6125C37.3438 96.9961 37.6655 94.3121 36.7298 93.3809C35.0873 93.1243 33.4547 92.8853 31.856 92.6238C34.9717 90.0151 32.5582 87.2505 31.3821 86.9937C28.74 86.4169 29.0979 91.5816 19.5695 88.4298C16.7225 87.4881 14.767 83.7477 14.6077 82.2485C8.39064 78.8989 3.25368 79.9474 1.57664 85.5858C6.02627 98.9347 18.4922 103.881 26.6657 106.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4118 52.6329C38.9071 53.0452 32.0884 51.7368 27.7977 49.8298C27.0896 51.3662 27.7762 50.7296 27.3121 51.2859C33.0311 57.3227 41.9022 57.9797 46.4118 52.6329Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1859 53.048C43.4849 61.0014 28.8055 63.0107 23.0236 53.048C18.74 53.048 10.2305 57.7352 4.68945 69.7502C26.8537 89.449 52.7906 80.0174 64.8255 69.7502C61.1704 61.2002 54.0192 54.5974 47.1859 53.048Z",
    fill: "#0B71D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5924 91.0823C70.3184 90.6056 69.5924 91.0823 71.2952 89.369C68.9537 74.8873 60.8521 56.4285 47.1854 52.8495C40.9877 63.3878 27.8213 60.4351 22.7124 52.8495C12.8597 54.639 1.66665 68.8999 -1.12491 86.8574C-1.27668 87.8337 0.782086 89.5589 2.84798 89.8768",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7974 49.6714C27.3207 52.8497 23.9835 52.6908 22.5532 52.8497",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8945 51.1015C44.3248 52.5317 46.0728 52.3728 47.1852 52.8496",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0368 67.8873L46.4341 67.8149C46.8755 67.7344 47.0694 67.4632 46.9915 67.0351L46.2054 62.7114L47.456 62.4835L48.2577 66.8928C48.4367 67.8774 47.8429 68.708 46.8277 68.893L46.2392 69.0003L46.0368 67.8873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1983 25.942C16.1963 36.4374 18.1459 42.1868 24.7684 47.657C31.3909 53.1272 53.8836 58.6268 56.5116 41.0113C57.7317 31.7355 51.0414 22.8375 50.1624 21.5547C40.9294 -8.32048 16.713 -11.3993 18.1983 -5.53104C21.2772 6.63302 30.3109 8.02035 37.3651 14.827C31.2903 14.7841 26.2184 16.8285 24.8554 17.8583C24.0936 15.3476 20.0293 10.7656 15.2436 6.88877C7.86091 0.90827 0.721931 1.76441 -3.80179 -1.64503C-15.1605 -5.64758 -23.668 -7.3475 -25.4074 2.21936C-27.1468 11.7862 3.14827 8.17151 18.1983 25.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8718 52.7729C48.5247 52.0651 51.8015 50.6192 53.8631 48.0302C33.5249 61.0009 15.0016 38.476 20.8927 22.5501C20.2358 22.3196 20.4346 22.2551 19.8886 21.9639C8.2408 38.9323 27.3158 55.2916 43.8718 52.7729Z",
    fill: "#EFF2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.0873 9.52351C-18.9848 8.38032 3.04872 10.406 18.9977 26.3736C19.9379 23.8866 18.0112 22.79 20.5696 22.8649C18.3439 14.3771 -2.71306 2.94249 -12.22 -1.4923L-24.0873 9.52351Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0703 21.3161C50.0134 21.0902 49.9521 20.8583 49.8866 20.6208C49.4917 20.0826 48.6491 19.4151 47.3117 19.3323C43.4574 11.9472 36.0995 2.83039 29.0105 -1.03834C22.6677 -4.49984 21.8428 -12.3832 29.8568 -7.93742C40.4214 -2.07665 47.6569 12.5432 49.8866 20.6208C50.1653 21.0006 50.221 21.3161 50.0703 21.3161Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0608 17.9275C12.9782 -3.44755 -6.08351 0.0893524 -4.7369 10.3342C-4.26413 13.9309 13.9087 18.1989 18.2649 25.8555",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1653 17.9593C28.6572 15.9862 32.3153 14.9547 35.8466 14.8822C38.3069 14.8317 40.7057 15.2467 42.944 16.1331C46.0468 17.3618 48.8413 19.4964 51.0637 22.5525C58.7222 33.0839 60.3751 51.568 43.7174 52.8953C26.5995 54.2593 12.9277 41.0754 18.2602 26.0417",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9703 -0.972487C33.0174 2.23552 37.6744 7.83786 40.0076 12.9296",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1928 21.2774C44.8913 1.69714 30.4789 -12.4153 21.5691 -8.44179C18.074 -6.88305 18.0627 -0.185888 24.5181 5.52941C26.8249 7.57169 34.9327 12.8339 36.3122 14.7652",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.106 45.1511C42.106 45.1511 44.865 41.2257 48.1705 45.0326",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.877 39.1072C46.7981 39.7753 46.9975 41.757 44.9998 43.3593",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7042 37.429C48.7437 38.6895 47.6176 39.7477 46.189 39.7925C44.7604 39.8372 43.5703 38.8517 43.5308 37.5911C45.3567 37.5339 46.7261 37.491 48.7042 37.429Z",
    fill: "#393F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1124 37.343L21.0518 37.7793",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5147 38.9102L21.805 40.1915",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1133 30.6837C32.5007 33.096 37.0338 34.9944 39.945 32.3706",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.467 33.7655C49.6986 35.2682 53.0104 36.0983 54.6799 34.011",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6657 106.047C31.8683 105.931 32.774 103.848 32.8754 102.703C35.7845 100.797 35.7808 99.2103 35.5453 98.6125C37.3438 96.9962 37.6655 94.3122 36.7298 93.3809C35.0873 93.1244 33.4547 92.8853 31.856 92.6238C34.9717 90.0152 32.5582 87.2506 31.3821 86.9938C28.74 86.417 29.0979 91.5816 19.5695 88.4299C16.7225 87.4882 14.767 83.7478 14.6077 82.2486C8.39064 78.899 3.25368 79.9475 1.57664 85.5858C6.02627 98.9347 18.4922 103.881 26.6657 106.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4123 52.6329C38.9076 53.0452 32.0889 51.7368 27.7982 49.8298C27.0901 51.3663 27.7767 50.7296 27.3126 51.286C33.0316 57.3227 41.9027 57.9797 46.4123 52.6329Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1859 53.048C43.4849 61.0014 28.8055 63.0107 23.0236 53.048C18.74 53.048 10.2305 57.7352 4.68945 69.7502C26.8537 89.449 52.7906 80.0174 64.8255 69.7502C61.1704 61.2002 54.0192 54.5974 47.1859 53.048Z",
    fill: "#0B71D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5924 91.0823C70.3184 90.6056 69.5924 91.0823 71.2952 89.369C68.9537 74.8873 60.8521 56.4285 47.1854 52.8495C40.9877 63.3878 27.8213 60.4351 22.7124 52.8495C12.8597 54.639 1.66665 68.8999 -1.12491 86.8574C-1.27668 87.8337 0.782086 89.5589 2.84798 89.8768",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7974 49.6714C27.3207 52.8497 23.9835 52.6908 22.5532 52.8497",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8945 51.1015C44.3248 52.5318 46.0728 52.3728 47.1852 52.8496",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0368 67.8873L46.4341 67.8149C46.8755 67.7345 47.0694 67.4632 46.9915 67.0352L46.2054 62.7115L47.456 62.4835L48.2577 66.8928C48.4367 67.8774 47.8429 68.708 46.8277 68.8931L46.2392 69.0003L46.0368 67.8873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1988 25.942C16.1968 36.4374 18.1464 42.1868 24.7689 47.657C31.3914 53.1273 53.8841 58.6268 56.512 41.0113C57.7322 31.7355 51.0419 22.8375 50.1629 21.5547C40.9299 -8.32047 16.7135 -11.3993 18.1988 -5.53102C21.2777 6.63304 30.3114 8.02036 37.3656 14.827C31.2908 14.7841 26.2189 16.8285 24.8559 17.8583C24.0941 15.3477 20.0298 10.7656 15.2441 6.88879C7.8614 0.908286 0.722419 1.76443 -3.8013 -1.64502C-15.16 -5.64756 -23.6675 -7.34749 -25.4069 2.21938C-27.1463 11.7862 3.14876 8.17152 18.1988 25.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8729 52.7729C48.5258 52.065 51.8026 50.6192 53.8642 48.0302C33.526 61.0008 15.0027 38.4759 20.8938 22.55C20.2369 22.3196 21.1175 22.1483 20.5715 21.8571C8.92371 38.8255 27.3169 55.2916 43.8729 52.7729Z",
    fill: "#EFF2F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.0861 9.52347C-18.9835 8.38028 3.04997 10.406 18.9989 26.3736C19.9391 23.8865 18.3131 22.5485 20.8715 22.6235C18.6458 14.1357 -6.0793 4.25868 -15.5862 -0.176115L-24.0861 9.52347Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3328 21.0735C50.2685 20.8649 50.2006 20.6503 50.1292 20.4301C49.8209 20.1339 49.2613 19.8079 48.3459 19.6221C44.1511 12.5781 36.7825 2.14794 30.1434 -2.17165C24.2032 -6.03655 22.2966 -12.5769 30.1204 -8.19972C40.5998 -2.33673 47.5921 12.6075 50.1292 20.4301C50.4992 20.7856 50.507 21.0982 50.3328 21.0735Z",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0623 17.9274C12.9796 -3.44761 -6.08204 0.089299 -4.73544 10.3341C-4.26267 13.9309 13.9101 18.1989 18.2664 25.8554",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6909 39.5115L60.9292 40.4466",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.604 41.2903L60.6553 43.073",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1678 17.9593C28.6598 15.9862 32.3178 14.9547 35.8492 14.8822C38.3094 14.8317 40.7082 15.2467 42.9465 16.1331C46.0494 17.3618 48.8438 19.4964 51.0662 22.5525C58.7248 33.0839 60.3776 51.568 43.7199 52.8953C26.6021 54.2593 12.6676 41.1765 18.0001 26.1429",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9722 -0.972533C33.0193 2.23547 37.6764 7.83781 40.0096 12.9296",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1947 21.2773C44.8933 1.69703 30.4809 -12.4154 21.5711 -8.44189C18.0759 -6.88316 18.0647 -0.185995 24.5201 5.52931C26.8268 7.57158 34.9347 12.8338 36.3141 14.7651",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4105 39.3823C46.3331 40.0086 46.2249 42.3733 44.2316 43.8645",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.296 37.793C48.3355 39.0535 47.2094 40.1117 45.7808 40.1564C44.3522 40.2012 43.1621 39.2156 43.1226 37.9551C44.9485 37.8979 46.3179 37.8549 48.296 37.793Z",
    fill: "#393F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1133 37.343L21.0527 37.7793",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5162 38.9102L21.8065 40.1915",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5427 29.5179C32.4135 30.225 37.1522 29.7433 39.3133 27.6407",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4483 29.5841C53.0786 30.2977 49.757 30.1159 48.3648 28.3848",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18457 8.10794C10.4685 8.7985 20.0239 13.4355 23.6517 23.5414",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1099 44.8668C45.689 43.655 42.1998 43.7442 40.3519 44.2351",
    stroke: "#393F47",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8643 39.6806C32.8619 39.3706 32.9144 39.042 33.0013 38.7136C33.3336 37.4576 34.9557 37.4767 35.3066 38.7276C35.4005 39.0627 35.458 39.389 35.4554 39.6806C35.4465 40.7123 34.6159 41.0839 34.1665 41.0839C33.7122 41.0839 32.8729 40.7854 32.8643 39.6806Z",
    fill: "#A9D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.085 39.5572C35.0847 39.6018 35.0826 39.6446 35.0787 39.6856C35.0222 40.2932 34.53 39.9429 34.5967 39.3364C34.602 39.289 34.6061 39.2427 34.6089 39.1981C34.6267 38.9125 34.9891 38.81 35.0399 39.0915C35.0694 39.2547 35.0861 39.4121 35.085 39.5572Z",
    fill: "#EFF2F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6478,
    cy: 32.7609,
    r: 2.03599,
    fill: "#393F47"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.8172,
    cy: 33.2176,
    rx: 1.66581,
    ry: 1.75835,
    fill: "#393F47"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoobler);
export default __webpack_public_path__ + "static/media/joobler.7a776a55675760fb4b2d59f9aad61bcd.svg";
export { ForwardRef as ReactComponent };